import CodeEditorHeader, { CodeEditorHeaderProps } from './CodeEditorHeader';
import withPresenter from './CodeEditorHeader.presenter';
import withInteractor from './CodeEditorHeader.interactor';

export type { CodeEditorHeaderProps };
export default withInteractor(withPresenter(CodeEditorHeader));
